import $http from '../../shared/http';

export const giving_types = {
  namespaced: true,
  state: () => {
    return {
      givingTypes: null,
      givingTypeData: null,
    };
  },
  getters: {
    getGivingTypes: (state) => state.givingTypes,
    getGivingTypeData: (state) => state.givingTypeData,
  },
  mutations: {
    setGivingTypes: (state, payload) => (state.givingTypes = payload),
    setGivingTypeData: (state, payload) => (state.givingTypeData = payload),
  },
  actions: {
    async loadGivingTypesAction({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`organisations/${churchId}/giving-types/list`, { canBeImpersonated: true })
          .then((response) => {
            commit('setGivingTypes', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async LOAD_GIVING_TYPE_DATA({ commit }, ID) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/giving-types/${ID}`)
          .then(async (response) => {
            commit('setGivingTypeData', response.data.data);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async CREATE_GIVING_TYPE(ctx, { form }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/giving-types`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async EDIT_GIVING_TYPE(ctx, { form, ID }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/giving-types/${ID}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async DELETE_GIVING_TYPE(ctx, { id }) {
      return $http()
        .delete(`/giving-types/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
};
